import {DepositRefundModel, STATUS_OPTIONS} from "./DepositRefundModel";

const STATUS_LABELS = Object.fromEntries(STATUS_OPTIONS.map((item) => [item.value, item.label]));

export class ImportDepositRefundModel {
    constructor(rowIndex, row = {}, errors = []) {
        this.rowIndex = rowIndex;
        this.id = row.deposit_refund_id ?? row.id ?? "";
        this.contractCode = row.contract_code ?? "";
        const status = row.processing_status;
        this.processingStatus =
            STATUS_LABELS[status] !== undefined
                ? STATUS_LABELS[status]
                : DepositRefundModel.statusLabel(status) || status || "";
        this.processingStatusCode = status ?? "";
        this.errors = Array.isArray(errors) ? errors : Object.values(errors || {});
    }
}
